<!--本页为左侧下拉菜单-->
<template>
  <div id="operationsMgContainer">
    <el-container class="navRouter">
      <el-aside class="leftNav">
        <el-menu :default-active="activePath()" style="padding-top: var(--middle-space)" router>
          <div v-for="(item, index) in navArr" :key="index" class="warp">
            <el-submenu v-if="item.sub[0]" :index="item.path">
              <template slot="title">
                <img v-if="item.icon" :src="item.icon" alt="" />
                <span class="name" :title="item.name">{{ item.name }}</span>
              </template>
              <el-menu-item v-for="(childrenItem, childrenIndex) in item.sub" :key="childrenIndex" :index="childrenItem.path">
                <img v-if="childrenItem.icon" class="childrenIcon" :src="childrenItem.icon" alt="" />
                <i v-else class="el-icon-takeaway-box childrenIcon"></i>
                <span slot="title" class="childrenItemName" :title="childrenItem.name">{{ childrenItem.name }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="item.path">
              <img v-if="item.icon" :src="item.icon" alt="" style="width: 16px; height: 16px" />
              <span slot="title" class="name" :title="item.name">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>

      <div class="rightContent">
        <el-main class="main">
          <router-view></router-view>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenuListApplication } from "@/CommonDP/utils/tree";
export default {
  name: "NavMenu",
  data() {
    return {};
  },
  computed: {
    ...mapState({ authRoutes: (state) => state.router.authRoutes }),
    navName() {
      return this.$route.matched[1].name;
    },
    standardName() {
      return this.$route.matched[2].name;
    },
    navArr() {
      const list = this.authRoutes.find(({ permissionKey }) => permissionKey === this.navName);
      if (list.childList && list.childList.length > 0) {
        var array = list.childList.find(({ permissionKey }) => permissionKey === this.standardName) || {};
      }
      if (array.childList && array.childList.length > 0) {
        var meauList = getMenuListApplication(array.childList);
      }
      console.log("authRoutes", this.authRoutes);
      return meauList;
    }
  },
  methods: {
    activePath() {
      if (this.$route.matched[3]) {
        return this.$route.matched[3].path;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#operationsMgContainer {
  width: 100%;
  height: 100%;
  padding: var(--middle-space);
  box-sizing: border-box;

  .navRouter {
    width: 100%;
    height: 100%;
    background-color: #eff1f6;

    .leftNav {
      width: 160px !important;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;
      overflow: hidden;
      /deep/ .el-menu {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border-right: 0;
      }
      .el-menu-item {
        border-right: 2px solid #fff;
        overflow: hidden;
        height: 36px !important;
        line-height: 36px !important;
        padding-left: var(--small-space) !important;
        margin-bottom: var(--middle-space) !important;
        align-items: center;
        font-size: 14px;
        min-width: 90px;
        img {
          margin-right: 5px;
        }
      }
      // 父级
      /deep/ .el-submenu__title {
        height: 36px !important;
        line-height: 36px !important;
        padding-left: var(--small-space) !important;
        margin-bottom: var(--middle-space) !important;
        border-right: 2px solid #fff;
        span {
          font-size: 14px !important;
          width: 85px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        img {
          margin-right: 5px;
        }
      }
      /deep/ .el-submenu__icon-arrow {
        right: 5px;
      }
      // 子级
      .el-menu-item {
        overflow: hidden;
        height: 36px !important;
        line-height: 36px !important;
        padding-left: var(--small-space) !important;
        margin-bottom: var(--middle-space) !important;
        border-right: 2px solid #fff;
        span {
          font-size: 14px !important;
          width: 92px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .titleBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            margin-right: 5px;
          }
        }
      }
      // 二级
      /deep/ .el-submenu .el-menu-item {
        padding-left: 20px !important;
        margin-bottom: var(--middle-space) !important;
      }

      .el-menu-item.is-active {
        background-color: rgba(85, 132, 255, 0.1) !important;
        color: #333;
        border-right: 2px solid var(--theme-color);
      }

      .el-menu-item:hover {
        background-color: rgba(85, 132, 255, 0.1) !important;
        border-right: 2px solid var(--theme-color);
      }

      .submenu__title:hover {
        background-color: rgba(85, 132, 255, 0.1) !important;
        border-right: 2px solid var(--theme-color);
      }
      .name {
        color: var(--key-color);
        font-size: 14px;
        line-height: 36px;
        width: 85px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .childrenIcon {
        margin-right: 0;
        // width: 30px;
        // height: 20px;
      }
      .childrenItemName {
        width: 90px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .leftNav:hover {
      overflow: auto;
    }

    .rightContent {
      flex: 1 1;
      height: 100%;
      overflow: hidden;

      .main {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0;
        padding-left: var(--middle-space);
      }
    }
  }
}
</style>
